import { privateRequest, type ApiResponse } from "../axios";

export type IProductModalState = {
  type: "product" | "childProduct" | "viewProduct" | "";
  isOpen: boolean;
  masterProductId?: number | string | null;
};

export type IProductInventoryModalState = {
  type: "updateInventory" | "inventoryLogs" | "";
  isOpen: boolean;
  productId: number | string | null;
};

const ENDPOINTS = {
  PRODUCTS: "api/CRM/MasterProducts",
  DELETE_PRODUCT: "api/CRM/Products",
  ADD_PRODUCT: "api/CRM/AddProduct",
  PRODUCT: "api/CRM/Product",
  UPDATE_PRODUCT: "api/CRM/UpdateProduct",
  PRODUCT_INVENTORY: "api/CRM/ProductInventory",
  ADD_CHILD_PRODUCT: "/api/CRM/AddChildProduct",
  CHILD_PRODUCTS: "/api/CRM/ChildProducts",
  UPDATE_CHILD_PRODUCT: "/api/CRM/UpdateProduct",
  DELETE_CHILD_PRODUCT: "api/CRM/ChildProduct",
  PRODUCT_BULK_UPLOAD: "api/CRM/ProductsBulkUpload",
  DOWNLOAD_ALL_PRODUCTS: "api/CRM/Products/ExportToExcel",
  PRODUCTS_REPORT: "api/CRM/Products/BulkUpload/FileName?loadtype=Products",
  VIEW_BULK_UPLOAD_REPORT: "api/CRM/Products/BulkUpload/ViewReport",
  EXPORT_BULK_UPLOAD_REPORT: "api/CRM/products/bulkUpload/ExportReport",
  EXPORT_BULK_UPLOAD_FILE: "api/CRM/products/BulkUpload/ExportFileReport",
};

const updateProductInventory = async (payload: any): Promise<any> => {
  const response = await privateRequest.put(
    ENDPOINTS.PRODUCT_INVENTORY,
    payload,
  );
  return response.data;
};

const fetchProductInventory = async (payload: { ProductId: string }) => {
  const response = await privateRequest.get(
    `${ENDPOINTS.PRODUCT_INVENTORY}/${payload.ProductId}`,
  );
  return response.data;
};

const fetchMasterProducts = async (
  payload: any,
): Promise<ApiResponse<{ Items: any[]; TotalRecords: number }>> => {
  const response = await privateRequest.get(ENDPOINTS.PRODUCTS, {
    params: payload,
  });
  return response.data;
};

const fetchChildMasterProducts = async (
  payload: any,
): Promise<ApiResponse<{ Items: any[]; TotalRecords: number }>> => {
  const response = await privateRequest.get(ENDPOINTS.CHILD_PRODUCTS, {
    params: payload,
  });
  return response.data;
};

const updateProduct = async (payload: any): Promise<any> => {
  const response = await privateRequest.post(ENDPOINTS.UPDATE_PRODUCT, payload);
  return response.data;
};

const updateChildProduct = async (payload: any): Promise<any> => {
  const response = await privateRequest.post(
    ENDPOINTS.UPDATE_CHILD_PRODUCT,
    payload,
  );
  return response.data;
};

const fetchProduct = async (
  payload: any,
): Promise<ApiResponse<{ Items: any[]; TotalRecords: number }>> => {
  const response = await privateRequest.get(ENDPOINTS.PRODUCT, {
    params: payload,
  });
  return response.data;
};

const deleteProduct = async (id: number) => {
  const res = await privateRequest.delete(`${ENDPOINTS.DELETE_PRODUCT}/${id}`);
  return res.data;
};

const deleteChildProduct = async (id: number) => {
  const res = await privateRequest.delete(
    `${ENDPOINTS.DELETE_CHILD_PRODUCT}/${id}`,
  );
  return res.data;
};

const addProduct = async (payload: any): Promise<any> => {
  const response = await privateRequest.post(ENDPOINTS.ADD_PRODUCT, payload);
  return response.data;
};

const addChildProduct = async (payload: any): Promise<any> => {
  const response = await privateRequest.post(
    ENDPOINTS.ADD_CHILD_PRODUCT,
    payload,
  );
  return response.data;
};

const productBulkUpload = async (payload: any): Promise<any> => {
  const res = await privateRequest.post<ApiResponse<any>>(
    `${ENDPOINTS.PRODUCT_BULK_UPLOAD}`,
    payload,
  );
  return res.data;
};

const downloadAllProducts = async (payload: any) => {
  const response = await privateRequest.post(
    ENDPOINTS.DOWNLOAD_ALL_PRODUCTS,
    payload,
    { responseType: "arraybuffer" }
  );
  return response;
};

const fetchProductsReport = async (payload: any) => {
  const response = await privateRequest.get(ENDPOINTS.PRODUCTS_REPORT, {
    params: payload,
  });
  return response.data;
};

const fetchBulkUploadViewReports = async (payload: any) => {
  const response = await privateRequest.get(ENDPOINTS.VIEW_BULK_UPLOAD_REPORT, {
    params: payload,
  });
  return response.data;
};

const exportBulkUploadReport = async (fileId: string) => {
  const response = await privateRequest.post(
    `${ENDPOINTS.EXPORT_BULK_UPLOAD_REPORT}/${fileId}`,
    {},
    { responseType: "arraybuffer" }
  );
  return response;
};

const exportBulkUploadFile = async (fileId: string) => {
  const response = await privateRequest.post(
    `${ENDPOINTS.EXPORT_BULK_UPLOAD_FILE}/${fileId}`,
    {},
    { responseType: "arraybuffer" }
  );
  return response;
};

export const productMasterService = {
  fetchMasterProducts,
  deleteProduct,
  addProduct,
  fetchProduct,
  updateProduct,
  updateProductInventory,
  fetchProductInventory,
  addChildProduct,
  fetchChildMasterProducts,
  updateChildProduct,
  deleteChildProduct,
  productBulkUpload,
  downloadAllProducts,
  fetchProductsReport,
  fetchBulkUploadViewReports,
  exportBulkUploadReport,
  exportBulkUploadFile,
};
